define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'],
        function($, _, Widget, Object) {

            var GlobalTypeWidget = function(element, options) {
                // GT-Codes
                this.gtcodes = $(element).data("initial-gtcodes");
                
                // Default Options
                var defaultOptions = {
                    hiddenClassName : 'is-hidden',
                    activeClassName : 'is-active',
                    collapsedClassName : 'is-collapsed',
                    prefix: 'hotelAttributes_',
                    delimiter: ';'
                };
                
                //Add default options and custom options
                this.addOptions(defaultOptions, options);
                
                // Widget Apply
                Widget.apply(this, arguments);
                                
                // Initialize
                this._init();
            };
            
            GlobalTypeWidget.prototype = $.extend(Object.create(Widget.prototype), {
                /**
                 * Initialize Widget
                 * 
                 */                
                _init: function() {
                    // Register Clickhandler to globaltype elements
                    $('[data-fcse-role="globaltypewidget--element"]', this.element).on('click', $.proxy(this._clickHandler, this));
                    
                    // Register moreListitems-Clickhandler
                    $('[data-fcse-role="globaltypewidget--listmorebutton"]', this.element).on('click', $.proxy(this._moreListItemsClickHandler, this));
                    
                    // Register listItem-Clickhandler
                    $('[data-fcse-role="globaltypewidget--list-item"]', this.element).find('input:checkbox').on('change', $.proxy(this._listItemclickHandler, this));
                    
                    // Check for hidden elements
                    this._checkHiddenElements();
                },
                
                /**
                 * Check for hidden elements by GT-Code and display each
                 * 
                 */                  
                _checkHiddenElements: function() {
                    var self = this;
                    $('ul.'+this.option('hiddenClassName')+' > li.'+this.option('activeClassName'), this.element).each(function(index, elementSelector) {
                        // Get Element
                        var element = $(elementSelector);
                        var container = element.closest('[data-fcse-role="globaltypewidget--list"]');
                        
                        // Display all sub-elements of container, that are hidden
                        container.find('ul.'+self.option('hiddenClassName'))
                                .removeClass(self.option('hiddenClassName'))
                                .addClass(self.option('collapsedClassName'));
                        
                        // Remove "more"-button
                        container.find('[data-fcse-role="globaltypewidget--listmorebutton"]').addClass(self.option('hiddenClassName'));
                    });
                },
                
                 /**
                 * Convert GT-Codes to value
                 * 
                 * @param value
                 */                 
                _processData: function(value) {
                    var params = {};
                    var self = this;
                    
                    // Get selected top-level values
                    $('[data-fcse-role="globaltypewidget--element"]', self.element).each(function(index, elementSelector) {
                        var element = $(elementSelector);
                        var id = element.data('id');
                        
                        if($.inArray(element.data('code'), self.gtcodes) >= 0) {
                            params[id] = element.data('code');
                        }
                    });
                    
                    // Get selected list-items
                    $('[data-fcse-role="globaltypewidget--list-item"]', self.element).each(function(index, elementSelector) {
                        var element = $(elementSelector);
                        var elementid = element.data('elementid');
                        
                        if($.inArray(element.data('code'), self.gtcodes) >= 0) {
                            params[elementid] += self.option('delimiter')+element.data('code');
                        }
                    });                      
                    
                    return params;
                },
                
                /**
                 * MoreListItems Click handler
                 * 
                 * @param event
                 */                
                _moreListItemsClickHandler: function(event) {
                   var element = $(event.currentTarget);

                   // Display all elements of the selected list 
                   element.closest('[data-fcse-role="globaltypewidget--list"]')
                          .children('.'+this.option('hiddenClassName'))
                          .addClass(this.option('collapsedClassName'))
                          .removeClass(this.option('hiddenClassName'));
                  
                   // Hide more-Button
                   element.addClass(this.option('hiddenClassName'))
                           .removeClass(this.option('collapsedClassName'));
                                     
                },     
                
                /**
                 * ListItem Click handler
                 * 
                 * @param event
                 */                
                _listItemclickHandler: function(event) {
                   var checkbox = $(event.currentTarget);
                    
                   // Set/Unset active class
                   checkbox.closest('[data-fcse-role="globaltypewidget--list-item"]').toggleClass(this.option('activeClassName'));
                   
                   // Set Values
                   this._propagateValues();
                },
                
                /**
                 * Click handler for main elements
                 * 
                 * @param event
                 */                
                _clickHandler: function(event) {
                   var element = $(event.currentTarget);
                    
                   // Set/Unset active class
                   element.toggleClass(this.option('activeClassName'));
                   
                   // Display list elements if any exist
                   this._displayListElements(element.data('id'));
                   
                   // Set Values
                   this._propagateValues();
                },
                
                /**
                 * Display list elements of an main element
                 * 
                 * @param id
                 */                
                _displayListElements: function(id) {
                    var element = $('[data-fcse-role="globaltypewidget--list"][data-id="'+id+'"]', this.element);

                    if(element.hasClass(this.option('hiddenClassName'))) {
                        // Remove hidden class
                        element.removeClass(this.option('hiddenClassName'));
                    } else {
                        // Add hidden Class
                        element.addClass(this.option('hiddenClassName'));
                        
                        // Remove active class from all list elements
                        var listitems = $('[data-fcse-role="globaltypewidget--list-item"]', element);
                        listitems.removeClass(this.option('activeClassName'));
                        
                        // Uncheck all checkboxes of list items
                        listitems.find('input:checkbox').prop('checked', false);
                    }
                },
                
                /**
                 * Get Scope Binding Map
                 * (it is used in Widgetfactory to bind each GT-Scope to the rootscope)
                 * 
                 */                
                getScopeBindingMap: function() {
                    var self = this;
                    var map = {};
                    $('[data-fcse-role="globaltypewidget--element"]', this.element).each(function(index, element) {
                        var id = $(element).data('id');
                        map[self.option('prefix')+id] = id;
                    });
                    
                    return map;
                },

                setValue: function(value) {
                    this.gtcodes = _.isObject(value) ? _.values(value) : [];
                    Widget.prototype.setValue.apply(this, arguments);
                },

                /**
                 * Set Value To UI
                 * 
                 */                
                setValueToUi: function() {
                    var self = this;
                    
                    // Unselect elements
                    $('[data-fcse-role="globaltypewidget--element"]', this.element).removeClass(this.option('activeClassName'));
                    
                    // Unselect list-elements
                    $('[data-fcse-role="globaltypewidget--list"]', this.element).addClass(this.option('hiddenClassName'));
                    
                    // Activate GT-Codes
                    $.each(self.gtcodes, function(index, gtcode) {
                        gtcode = gtcode.split(self.option('delimiter'));
                        // Activate elements
                        var elements = $('[data-fcse-role="globaltypewidget--element"][data-code="'+gtcode[0]+'"]', self.element);
                        elements.addClass(self.option('activeClassName'));
                        
                        // Display list elements of active elements
                        elements.each(function(index, elementSelector) {
                            var element = $(elementSelector);
                            self._displayListElements(element.data('id'));
                        });
                    });
                },
                
                /**
                 * Propagate values
                 * 
                 */
                _propagateValues: function() {
                    // Get Values from UI
                    var val = this.getValueFromUi();
                    
                    // Set UI Values to Scope
                    this.setValue(val);
                },                
               
                /**
                 * Get Value From UI
                 * 
                 */                
                getValueFromUi: function() {
                    var self = this;
                    var params = {};
                    self.gtcodes = [];
                    
                    // Get selected top-level values
                    $('[data-fcse-role="globaltypewidget--element"]', this.element).each(function(index, elementSelector) {
                        var element = $(elementSelector);
                        var id = element.data('id');
                        
                        if(element.hasClass(self.option('activeClassName'))) {
                            params[id] = element.data('code');
                            self.gtcodes.push(element.data('code'));
                        }
                    });
                    
                    // Get selected list-items
                    $('[data-fcse-role="globaltypewidget--list-item"]', this.element).each(function(index, elementSelector) {
                        var element = $(elementSelector);
                        var elementid = element.data('elementid');
                        
                        if(element.hasClass(self.option('activeClassName'))) {
                            params[elementid] += self.option('delimiter')+element.data('code');
                            self.gtcodes.push(element.data('code'));
                        }
                    });                    
                    
                    return params;
                }
            });

            GlobalTypeWidget.getScopeBindingMap = function() {
                var map = {};
                $('[data-fcse-role="globaltypewidget--element"]').each(function(index, element) {
                    var id = $(element).data('id');
                    map['hotelAttributes_' + id] = id;
                });

                return map;
            };

            return GlobalTypeWidget;
        }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/globaltype/globalTypeWidget.js